const ErrorMessages = {
    USERNAME_INVALID: "Username is invalid",
    USERNAME_REQUIRED: "Username is required",
    PASSWORD_REQUIRED: "Please enter Password",
    NAME_TOO_SHORT: "Entity Name is too short",
    NAME_TOO_LONG: "Entity Name is too LONG",
    PASSWORD_LENGTH: "Password must be atleast 8 characters long",
    PASSWORDS_DONT_MATCH: "Passwords do not match",
    PHONE_NUM_INVALID: "Phone number is not valid",
    PHONE_NUM_SHORT: "Phone number is too short",
    PHONE_NUM_LONG: "Phone number is too LONG",
    EMAIL_INVALID: "Email is invalid",
    EIN_INVALID: "EIN is not valid",
    EIN_REQUIRED: "Please enter EIN",
    WEBSITE_INVALID: "Website is not valid",
    ENTITY_NAME_REQUIRED: "Please provide a Name",
    EMAIL_REQUIRED: "Please provide an email address.",
    PHONE_NUM_REQUIRED: "Please enter a Phone number.",
    FIRSTNAME_REQUIRED: "Firstname is required",
    LASTNAME_REQUIRED: "Lastname is required",
    SERVER_ERROR: "Request failed at Server",
    GENDER_REQUIRED: "Please select a value",
    VERIFICATION_CODE_REQUIRED: "Please enter verification code",
    ZIPCODE_REQUIRED: "Please enter Zip Code"
}

export default ErrorMessages;